import axios, { AxiosResponse } from 'axios'
import { axiosTeleConsulta } from '../../../../tele-consulta/core/axiosTeleConsulta'
import { type Gravacao } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const iniciarGravacao = (idAtendimento: number): Promise<Gravacao> =>
  axios
    .put(`${API_URL}/atendimentos/${idAtendimento}/gravacao`)
    .then((resp: AxiosResponse<Gravacao>) => resp.data)

export const pararGravacao = (idAtendimento: number): Promise<Gravacao | null> =>
  axios
    .delete(`${API_URL}/atendimentos/${idAtendimento}/gravacao`)
    .then((resp: AxiosResponse<Gravacao | null>) => resp.data || null)

export const sttUrl = (idAtendimento: number): string =>
  `${API_URL}/atendimentos/${idAtendimento}/transcricao`

export const iniciarStt = (idAtendimento: number): Promise<void> =>
  axios.put(sttUrl(idAtendimento)).then(() => undefined)

export const pararStt = (idAtendimento: number): Promise<void> =>
  axios.delete(sttUrl(idAtendimento)).then(() => undefined)

export const listarGravacoes = (idAtendimento: number, isPaciente = false): Promise<Gravacao[]> =>
  (isPaciente ? axiosTeleConsulta : axios)
    .get(`${API_URL}/atendimentos/${idAtendimento}/gravacoes`)
    .then((resp: AxiosResponse<Gravacao[]>) => resp.data)
